
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-06-29-r3f-mixing-controls",
      function () {
        return require("private-next-pages/blogs/2025-06-29-r3f-mixing-controls/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-06-29-r3f-mixing-controls"])
      });
    }
  